import React from 'react';
import { requestDeposit } from '../../messagebus';

export const DepositButton = ({ label }) => {
  return <div className="sb-header__item">
    <button
      data-test-id='@sitebase/deposit-button_pi-header__deposit-button'
      className="action-deposit__button"
      onClick={requestDeposit}
    >
      {label}
    </button>
  </div>
}
